import { Box, Container } from '@mui/material';
import React from 'react';
import { getResponsiveHeight, getResponsiveSize } from '../../utils/responsive';

const Banner = () => {
  return (
     
       <Box  sx={styles.background} >
    <Box sx={styles.box2} >
        <Box sx={styles.typography}>JOIN OUR HANDS TO EXPAND GLOBALLY</Box>

        <Container sx={styles.text1}>
        From humble beginnings in India to over 650+ franchises across Asia, UClean has revolutionized the laundry industry with its innovative, tech-enabled solutions. Founded by a visionary IITian, UClean has grown into Asia's largest laundry franchise network, setting new benchmarks in quality, convenience, and sustainability.
        </Container>
      </Box>
    
       </Box>
  
  );
};

const styles = {
  background: {
    width:getResponsiveSize(1920),
    height:getResponsiveHeight(516),
    background: '#003A26'
  },
  typography: {
    color: '#fff',
    fontSize: getResponsiveSize(45),
   fontFamily: ' "Poppins", serif ',
fontWeight: 700,
    lineHeight: 1.2,
    textAlign: 'center',
    mt: getResponsiveSize(10),
  },
  text1: {
    lineHeight: 1.2,
    height:getResponsiveHeight(79), 
   fontFamily: ' "Poppins", serif ',
    fontWeight: 400,
    fontSize: getResponsiveSize(18),
    color: '#fff',
    textAlign: 'center',
    mb: getResponsiveHeight(6),
    paddingTop : getResponsiveHeight(6),
  },
  box2: {
    margin: 'auto',
    paddingTop: getResponsiveSize(10),
  }
};

export default Banner;
